import { generateBidIncrements } from '@bonhams1793/bonhams-typescript'

export const getBidIncrements = ({
  biddingPolicy,
  currentBidValue,
  isWinningBidder,
  maxBidValue,
  maxPossibleBidValue,
  numberOfOptions,
}: GeBidIncremementsParams) => {
  if (typeof maxPossibleBidValue === 'number') {
    return generateBidIncrements({
      policy: biddingPolicy,
      currentBid: currentBidValue,
      maxPossibleBid: maxPossibleBidValue,
    })
  }

  if (isWinningBidder && maxBidValue) {
    return generateBidIncrements({
      policy: biddingPolicy,
      currentBid: currentBidValue,
      maxPossibleBid: maxBidValue,
      amountOfExtraOptions: numberOfOptions,
    })
  }

  return generateBidIncrements({
    policy: biddingPolicy,
    currentBid: currentBidValue,
    amountOfOptions: numberOfOptions,
  })
}

export interface GeBidIncremementsParams {
  biddingPolicy: Record<string, number[]>
  numberOfOptions: number
  maxBidValue?: number
  maxPossibleBidValue?: number
  currentBidValue: number
  isCurrentBidIncluded?: boolean
  isWinningBidder: boolean
}
